/* src/app/components/payroll/timesheets/timesheet-payroll-adjustment/timesheet-payroll-adjustment.component.css */
.table-style {
  width: 100%;
}
.ant-form-item {
  margin-bottom: 10px !important;
}
.error-message1 {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
}
::ng-deep ppl-popup-dialog .popup-dialog.position-dialog.center {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
p-calendar {
  display: flex;
}
/*# sourceMappingURL=timesheet-payroll-adjustment.component-RHTAAWYV.css.map */
